import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _additionalData = {
    members: '_member',
    currentMember: '_member',
    memberBadges: '_memberBadges',
    votes: '_vote',
    ratingsSummary: '_getResourceSummaryResponse',
};
var _addReactionRequest = {};
var _addReactionResponse = {};
var _appEmbedData = { image: '_media' };
var _attachment = {
    image: '_commonImage',
    video: '_videoV2',
    audio: '_audio',
    document: '_document',
};
var _audio = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _badge = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _bulkListCommentsByResourceRequest = {};
var _bulkListCommentsByResourceResponse = {
    responses: '_listCommentsByResourceResponse',
};
var _bulkListContextRequest = {};
var _bulkListContextResponse = { additionalData: '_additionalData' };
var _comment = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    commentDate: 'google.protobuf.Timestamp',
    content: '_commentContent',
    draftContent: '_commentContent',
};
var _commentContent = {
    commentDate: 'google.protobuf.Timestamp',
    richContent: '_richContent',
    attachments: '_attachment',
};
var _commentContentRevision = {
    createdDate: 'google.protobuf.Timestamp',
    content: '_richContent',
};
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _createCommentRequest = { request: '_v1CreateCommentRequest' };
var _createCommentResponse = {
    response: '_v1CreateCommentResponse',
    vote: '_vote',
};
var _deleteCommentRequest = {};
var _deleteCommentResponse = {};
var _design = { poll: '_pollDesign' };
var _document = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getBulkCommentsRequest = {};
var _getBulkCommentsResponse = {
    comments: '_comment',
    additionalData: '_additionalData',
};
var _getCommentRequest = {};
var _getCommentResponse = {
    response: '_v1GetCommentResponse',
    additionalData: '_additionalData',
};
var _getCommentsAdditionalDataRequest = {};
var _getCommentsAdditionalDataResponse = {
    additionalData: '_additionalData',
};
var _getCommentThreadRequest = {};
var _getCommentThreadResponse = {
    response: '_v1GetCommentThreadResponse',
    additionalData: '_additionalData',
};
var _getResourceSummaryResponse = { average: 'DOUBLE' };
var _imageData = { image: '_media' };
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _listCommentContentRevisionsRequest = {};
var _listCommentContentRevisionsResponse = {
    response: '_v1ListCommentContentRevisionsResponse',
    additionalData: '_additionalData',
};
var _listCommentsByResourceRequest = {};
var _listCommentsByResourceResponse = {
    response: '_v1ListCommentsByResourceResponse',
    additionalData: '_additionalData',
};
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _markCommentRequest = {};
var _markCommentResponse = { response: '_v1MarkCommentResponse' };
var _media = { duration: 'google.protobuf.DoubleValue' };
var _member = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lastLoginDate: 'google.protobuf.Timestamp',
};
var _memberBadges = { badges: '_badge' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _removeReactionRequest = {};
var _removeReactionResponse = {};
var _repliesListResponse = { replies: '_comment' };
var _reportCommentRequest = {};
var _reportCommentResponse = {};
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _unmarkCommentRequest = {};
var _unmarkCommentResponse = { response: '_v1UnmarkCommentResponse' };
var _updateCommentRequest = { request: '_v1UpdateCommentRequest' };
var _updateCommentResponse = { response: '_v1UpdateCommentResponse' };
var _v1CreateCommentRequest = { comment: '_comment' };
var _v1CreateCommentResponse = { comment: '_comment' };
var _v1GetCommentResponse = { comment: '_comment' };
var _v1GetCommentThreadResponse = {
    comments: '_comment',
    commentReplies: 'Map#_repliesListResponse',
};
var _v1ListCommentContentRevisionsResponse = {
    commentContentRevisions: '_commentContentRevision',
};
var _v1ListCommentsByResourceResponse = {
    comments: '_comment',
    commentReplies: 'Map#_repliesListResponse',
};
var _v1MarkCommentResponse = { comment: '_comment' };
var _v1UnmarkCommentResponse = { comment: '_comment' };
var _v1UpdateCommentRequest = { comment: '_comment' };
var _v1UpdateCommentResponse = { comment: '_comment' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    posters: '_commonImage',
};
var _vote = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl(opts) {
    var domainToMappings = {
        '*.wixapps.net': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/comments-middleware',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'sharedgallery.wixapps.net': [
            {
                srcPath: '/_api/comments-middleware/v1',
                destPath: '/v1',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/comments-middleware',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function createComment(payload) {
    var _a = serializer(_createCommentRequest, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _v1CreateCommentRequest: _v1CreateCommentRequest,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _v1CreateCommentResponse: _v1CreateCommentResponse,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
        _vote: _vote,
    }).fromJSON;
    function __createComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'POST',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.CreateComment',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createComment.fromReq = fromReq;
    __createComment.__isAmbassador = true;
    return __createComment;
}
export function updateComment(payload) {
    var _a = serializer(_updateCommentRequest, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _v1UpdateCommentRequest: _v1UpdateCommentRequest,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _v1UpdateCommentResponse: _v1UpdateCommentResponse,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'PUT',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.UpdateComment',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/{request.comment.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateComment.fromReq = fromReq;
    __updateComment.__isAmbassador = true;
    return __updateComment;
}
export function deleteComment(payload) {
    var _a = serializer(_deleteCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCommentResponse, {}).fromJSON;
    function __deleteComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'DELETE',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.DeleteComment',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/{request.commentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteComment.fromReq = fromReq;
    __deleteComment.__isAmbassador = true;
    return __deleteComment;
}
export function addReaction(payload) {
    var _a = serializer(_addReactionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addReactionResponse, {}).fromJSON;
    function __addReaction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'PUT',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.AddReaction',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/{commentId}/reactions/{reactionCode}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addReaction.fromReq = fromReq;
    __addReaction.__isAmbassador = true;
    return __addReaction;
}
export function removeReaction(payload) {
    var _a = serializer(_removeReactionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeReactionResponse, {}).fromJSON;
    function __removeReaction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'DELETE',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.RemoveReaction',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/{commentId}/reactions/{reactionCode}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeReaction.fromReq = fromReq;
    __removeReaction.__isAmbassador = true;
    return __removeReaction;
}
export function markComment(payload) {
    var _a = serializer(_markCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _v1MarkCommentResponse: _v1MarkCommentResponse,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __markComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'PUT',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.MarkComment',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/{request.commentId}/mark',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markComment.fromReq = fromReq;
    __markComment.__isAmbassador = true;
    return __markComment;
}
export function unmarkComment(payload) {
    var _a = serializer(_unmarkCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unmarkCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _v1UnmarkCommentResponse: _v1UnmarkCommentResponse,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __unmarkComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'PUT',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.UnmarkComment',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/{request.commentId}/unmark',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unmarkComment.fromReq = fromReq;
    __unmarkComment.__isAmbassador = true;
    return __unmarkComment;
}
export function reportComment(payload) {
    var _a = serializer(_reportCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportCommentResponse, {}).fromJSON;
    function __reportComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'PUT',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.ReportComment',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/{commentId}/report',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportComment.fromReq = fromReq;
    __reportComment.__isAmbassador = true;
    return __reportComment;
}
export function getComment(payload) {
    var _a = serializer(_getCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCommentResponse, {
        _additionalData: _additionalData,
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getResourceSummaryResponse: _getResourceSummaryResponse,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _member: _member,
        _memberBadges: _memberBadges,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _v1GetCommentResponse: _v1GetCommentResponse,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
        _vote: _vote,
    }).fromJSON;
    function __getComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'GET',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.GetComment',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/{request.commentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getComment.fromReq = fromReq;
    __getComment.__isAmbassador = true;
    return __getComment;
}
export function listCommentContentRevisions(payload) {
    var _a = serializer(_listCommentContentRevisionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCommentContentRevisionsResponse, {
        _additionalData: _additionalData,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _commentContentRevision: _commentContentRevision,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getResourceSummaryResponse: _getResourceSummaryResponse,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _member: _member,
        _memberBadges: _memberBadges,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _v1ListCommentContentRevisionsResponse: _v1ListCommentContentRevisionsResponse,
        _video: _video,
        _videoData: _videoData,
        _vote: _vote,
    }).fromJSON;
    function __listCommentContentRevisions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'GET',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.ListCommentContentRevisions',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/revisions/{request.commentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCommentContentRevisions.fromReq = fromReq;
    __listCommentContentRevisions.__isAmbassador = true;
    return __listCommentContentRevisions;
}
export function getBulkComments(payload) {
    var _a = serializer(_getBulkCommentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBulkCommentsResponse, {
        _additionalData: _additionalData,
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getResourceSummaryResponse: _getResourceSummaryResponse,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _member: _member,
        _memberBadges: _memberBadges,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
        _vote: _vote,
    }).fromJSON;
    function __getBulkComments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'POST',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.GetBulkComments',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment/bulk',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBulkComments.fromReq = fromReq;
    __getBulkComments.__isAmbassador = true;
    return __getBulkComments;
}
export function listCommentsByResource(payload) {
    var _a = serializer(_listCommentsByResourceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCommentsByResourceResponse, {
        _additionalData: _additionalData,
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getResourceSummaryResponse: _getResourceSummaryResponse,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _member: _member,
        _memberBadges: _memberBadges,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _repliesListResponse: _repliesListResponse,
        _richContent: _richContent,
        _v1ListCommentsByResourceResponse: _v1ListCommentsByResourceResponse,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
        _vote: _vote,
    }).fromJSON;
    function __listCommentsByResource(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'GET',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.ListCommentsByResource',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/list-comments-by-resource',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCommentsByResource.fromReq = fromReq;
    __listCommentsByResource.__isAmbassador = true;
    return __listCommentsByResource;
}
export function getCommentThread(payload) {
    var _a = serializer(_getCommentThreadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCommentThreadResponse, {
        _additionalData: _additionalData,
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getResourceSummaryResponse: _getResourceSummaryResponse,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _member: _member,
        _memberBadges: _memberBadges,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _repliesListResponse: _repliesListResponse,
        _richContent: _richContent,
        _v1GetCommentThreadResponse: _v1GetCommentThreadResponse,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
        _vote: _vote,
    }).fromJSON;
    function __getCommentThread(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'GET',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.GetCommentThread',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/comment-thread',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCommentThread.fromReq = fromReq;
    __getCommentThread.__isAmbassador = true;
    return __getCommentThread;
}
export function bulkListCommentsByResource(payload) {
    var _a = serializer(_bulkListCommentsByResourceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkListCommentsByResourceResponse, {
        _additionalData: _additionalData,
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _comment: _comment,
        _commentContent: _commentContent,
        _commonImage: _commonImage,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _getResourceSummaryResponse: _getResourceSummaryResponse,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _listCommentsByResourceResponse: _listCommentsByResourceResponse,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _member: _member,
        _memberBadges: _memberBadges,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _repliesListResponse: _repliesListResponse,
        _richContent: _richContent,
        _v1ListCommentsByResourceResponse: _v1ListCommentsByResourceResponse,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
        _vote: _vote,
    }).fromJSON;
    function __bulkListCommentsByResource(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'POST',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.BulkListCommentsByResource',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/bulk/list-comments-by-resource',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkListCommentsByResource.fromReq = fromReq;
    __bulkListCommentsByResource.__isAmbassador = true;
    return __bulkListCommentsByResource;
}
export function bulkListContext(payload) {
    var _a = serializer(_bulkListContextRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkListContextResponse, {
        _additionalData: _additionalData,
        _badge: _badge,
        _getResourceSummaryResponse: _getResourceSummaryResponse,
        _member: _member,
        _memberBadges: _memberBadges,
        _vote: _vote,
    }).fromJSON;
    function __bulkListContext(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'POST',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.BulkListContext',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/bulk/list-contexts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkListContext.fromReq = fromReq;
    __bulkListContext.__isAmbassador = true;
    return __bulkListContext;
}
export function getCommentsAdditionalData(payload) {
    var _a = serializer(_getCommentsAdditionalDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCommentsAdditionalDataResponse, {
        _additionalData: _additionalData,
        _badge: _badge,
        _getResourceSummaryResponse: _getResourceSummaryResponse,
        _member: _member,
        _memberBadges: _memberBadges,
        _vote: _vote,
    }).fromJSON;
    function __getCommentsAdditionalData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.middleware.v1.enriched_comment',
            method: 'POST',
            methodFqn: 'wix.comments.middleware.v1.CommentsMiddleware.GetCommentsAdditionalData',
            url: resolveWixCommentsMiddlewareV1CommentsMiddlewareUrl({
                protoPath: '/v1/bulk/additional-data',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCommentsAdditionalData.fromReq = fromReq;
    __getCommentsAdditionalData.__isAmbassador = true;
    return __getCommentsAdditionalData;
}
//# sourceMappingURL=http.impl.js.map